// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"yh","place_order_copy":"zh","next_order_copy":"Ah","title_wrapper":"Bh","get_it_now_row":"Ch","get_it_now_remaining_items":"Eh","get_it_now_remaining_items_mob":"Fh","order_summary":"Gh","additional_items":"Hh","account_content_slider":"Ih","ingredient_carousel":"Jh","ingredient_carouselwrapper":"Kh","account_content_slide":"Lh","account_subscription_section_mob":"Mh","carouselwrapper":"Nh"};
    if(module.hot) {
      // 1711394573808
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  